import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Link, Outlet, useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { Dialog, PrimaryButton, Stack, TextField } from '@fluentui/react'
import { CopyRegular } from '@fluentui/react-icons'

import ETF from '../../assets/logo.png'
import { AppStateContext } from '../../state/AppProvider'

import styles from './Layout.module.css'

import { msalInstance } from '../../auth/auth'
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/app-sidebar'
import { BookMarked} from 'lucide-react'

const Layout = () => {
  const [isSharePanelOpen, setIsSharePanelOpen] = useState<boolean>(false)
  const [copyClicked, setCopyClicked] = useState<boolean>(false)
  const [copyText, setCopyText] = useState<string>('Copy URL')
  const [logo, setLogo] = useState('')
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui
  const admin = appStateContext?.state.environmentVariablesList?.environment_variables?.admin

  const [isReady, setIsReady] = useState(false)

  const navigate = useNavigate()
  const [docWizard, setDocWizard] = useState(false)
  const location = useLocation()
  const outletContext = useOutletContext<{ clickTab1?: () => void }>()
  const dispatch = appStateContext?.dispatch

  const handleSharePanelDismiss = () => {
    setIsSharePanelOpen(false)
    setCopyClicked(false)
    setCopyText('Copy URL')
  }

  useEffect(() => {
  const init = async () => {
    const accounts = msalInstance.getAllAccounts()
    const activeAccount = msalInstance.getActiveAccount()

    // If already logged in
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0])
      setIsReady(true)
      return
    }

    // 🚨 Prevent redirect loop using session flag
    const isRedirecting = sessionStorage.getItem("msal_redirect_in_progress")

    if (!isRedirecting) {

      sessionStorage.setItem("msal_redirect_in_progress", "true")

      await msalInstance.loginRedirect({
        scopes: [import.meta.env.VITE_API_REDIRECT_SCOPE]
      })

      return
    }

  }

  init()
}, [])

  useEffect(() => {
    if (!appStateContext?.state.isLoading) {
      setLogo(ui?.logo || ETF)
    }
  }, [appStateContext?.state.isLoading])

  useEffect(() => {
    if (copyClicked) {
      setCopyText('Copied URL')
    }
  }, [copyClicked])

  useEffect(() => {}, [appStateContext?.state.isCosmosDBAvailable.status])

  const getSidebarDynamicContent = () => {
    if ((location.pathname === "/" || location.pathname.startsWith("/c/")) && !docWizard) {
      return { chatHistory: true };
    }
    return {}; 
  }

  const goHome = useCallback(() => navigate('/'), [navigate])

  const layoutButtonAction = useMemo(() => {
    if (location.pathname === '/' || location.pathname.startsWith('/c/')) {
      return outletContext?.clickTab1
    }
    return goHome
  }, [location.pathname, outletContext?.clickTab1, goHome])

useEffect(() => {
  if (dispatch) {
  dispatch({
    type: 'SET_LAYOUT_BUTTON_ACTION',
    payload: layoutButtonAction
  })

  return () => {
    dispatch({ type: 'SET_LAYOUT_BUTTON_ACTION', payload: undefined })
  }
}

}, [dispatch, layoutButtonAction])
  if (!isReady) return <div>Loading...</div>
  return (
    <SidebarProvider className='bg-slate-50'>
      <AppSidebar
        header={{
          logoSrc: logo,
          alt: 'Chatty Logo',
          link: '/',
          label: 'CHATTY'
        }}
        content={{
          text: 'New Chat',
          buttonText: 'App Explorer',
          dropdownItems: [
            { link: '/litReview', text: 'Literature Review', icon: BookMarked },
          ]
        }}
        dynamicContent={getSidebarDynamicContent()}
        admin={admin}
        onAdminClick={() => navigate('/admin')}
      />
      <main className="flex-1 flex flex-col overflow-hidden">
        <SidebarTrigger className="bg-slate-100 rounded-none rounded-r-lg border-r border-y border-slate-300 -ml-1 mt-4 hover:bg-slate-200" />
        <Outlet context={{ docWizard, setDocWizard }}/>
      </main>
    </SidebarProvider>
    /*<div className={styles.layout}>
      <header className={styles.header} role={'banner'}>
        <Stack horizontal verticalAlign="center" horizontalAlign="space-between">
          <Stack horizontal verticalAlign="center">
            <img src={logo} className={styles.headerIcon} aria-hidden="true" alt="" />
            <Link to="/" className={styles.headerTitleContainer}>
              <h1 className={styles.headerTitle}>{ui?.title.toUpperCase()}</h1>
            </Link>
          </Stack>
          <Stack horizontal tokens={{ childrenGap: 4 }} className={styles.shareButtonContainer}>
            {admin && <PrimaryButton onClick={() => navigate('/admin')} text="Admin Page" />}
          </Stack>
        </Stack>
      </header>
      <Outlet />
    </div>*/
  )
}

export default Layout
